import find from 'lodash/find';
import React, { Component, PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import Loader from 'react-loader';
import ListGroup from 'react-bootstrap/lib/ListGroup';
import ListGroupItem from 'react-bootstrap/lib/ListGroupItem';
import Panel from 'react-bootstrap/lib/Panel';

class HomeLibrarySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: !props.filters || !props.filters.unit,
    };
  }

  render() {
    const {
      intl,
      isFetchingUnits,
      onFiltersChange,
      filters,
      unitOptions,
    } = this.props;

    const currentUnit = find(unitOptions, option => option.value === filters.unit);
    const defaultTitle = intl.formatMessage({
      id: 'search_filters.unit',
      defaultMessage: 'Kirjasto',
    });
    const currentUnitName = currentUnit ? currentUnit.label : defaultTitle;

    return (
      <Loader loaded={!isFetchingUnits}>
        <Panel
          collapsible
          header={currentUnitName}
          expanded={this.state.open}
          onSelect={() => this.setState({ open: !this.state.open })}
        >
          <ListGroup fill>
            {unitOptions.map(option => (
              <ListGroupItem key={option.value}>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    onFiltersChange({ unit: option.value });
                    this.setState({ open: false });
                  }}
                >
                  {option.label}
                </a>
              </ListGroupItem>
            ))}
          </ListGroup>
        </Panel>
      </Loader>
    );
  }
}

HomeLibrarySelector.propTypes = {
  intl: intlShape.isRequired,
  isFetchingUnits: PropTypes.bool.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  unitOptions: PropTypes.array.isRequired,
};

export default injectIntl(HomeLibrarySelector);



/** WEBPACK FOOTER **
 ** ./app/components/common/HomeLibrarySelector.js
 **/